
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import InfoBoxWarning from '@components/shared/ui/InfoBoxWarning.vue';
import SettingsTitleBar from '@components/settings/SettingsTitleBar.vue';
import SettingsPanel from '@components/settings/SettingsPanel.vue';
import { LoadState } from '@/utils/types';
import { ruleV2Icons } from '@util/settingIcons'
import { RuleWithModels } from '@/models/SettingsModels';
import AppPage from '@components/new-styleguide/AppPage.vue';
import AppHeader from '@components/new-styleguide/AppHeader.vue';
import AppContent from '@components/new-styleguide/AppContent.vue';
import AppListItem, { ListItem } from '@components/new-styleguide/AppListItem.vue';
import { channelSubtitle } from '@util/channelSubtitle';

const TriplogModule = namespace('Triplog');
const SettingsModule = namespace('Settings');

@Component({
  name: 'RulesOverview',
  components: {
    AppListItem,
    SettingsPanel,
    InfoBoxWarning,
    SettingsTitleBar,
    AppPage,
    AppContent,
    AppHeader
  }
})
export default class RulesOverview extends Vue {
  @TriplogModule.Action('fetchVehicles')
  private fetchVehicles;

  @SettingsModule.Action('fetchRulesV2')
  private fetchRules;

  @SettingsModule.Getter('getRulesV2')
  private rules: RuleWithModels[];

  @SettingsModule.Getter('getRulesV2Status')
  private rulesStatus: LoadState;

  @SettingsModule.Action('updateRuleActive')
  private updateRuleActive;

  @SettingsModule.Action('fetchPilots')
  private fetchPilots;

  @SettingsModule.Action('fetchTags')
  private fetchTags;

  @SettingsModule.Action('fetchZones')
  private fetchZones;

  @SettingsModule.Getter('getTagsStatus')
  private tagsStatus: LoadState;

  @SettingsModule.Getter('getPilotsStatus')
  private pilotsStatus: LoadState;

  @SettingsModule.Getter('getZonesStatus')
  private zonesStatus: LoadState;

  private created() {
    this.fetchVehicles();
    this.fetchRules();
    this.fetchPilots();
    this.fetchTags();
    this.fetchZones();
  }

  get backButton() {
    return { text: 'Zurück zu Anpassen', location: { name: 'mySettings' } };
  }

  get addButton() {
    return { text: 'Neue Regel anlegen', location: { name: 'rulesAdd' } };
  }

  get rulesHeaderText() {
    return 'Regeln werden bei Abfahrt oder Ankunft an bestimmten häufigen Zielen ausgelöst, und ermöglichen es Fahrten automatisch zu kennzeichnen.';
  }

  get createItem() {
    return { title: 'Neue Regel anlegen', tagIcon: { value: 'tag_plus', color: '#FFDC00', fill: 'black' }, location: { name: 'rulesAdd' } };
  }

  get mappedRules(): ListItem[] {
    if (this.isLoading) {
      return []
    }

    return this.rules.map(
      r => ({ id: r.id, title: r.name, subtitle: channelSubtitle(r), switchState: r.active, ...ruleV2Icons(r), hoverText: 'Regel bearbeiten', location: { name: 'ruleEdit', params: { id: r.id.toString() } } })
    );
  }

  private toggleRule(id: string, active: boolean) {
    this.updateRuleActive({ id, ruleActive: { active } });
  }

  get errorLoading() {
    return this.rulesStatus === LoadState.Error;
  }

  get isLoading() {
    return this.rulesStatus === LoadState.Loading
      || this.tagsStatus === LoadState.Loading
      || this.pilotsStatus === LoadState.Loading
      || this.zonesStatus === LoadState.Loading;
  }
}
